import React from 'react';
import { ChangeType } from 'apollo/generated/client-operations';
import { FormDialog } from 'dialog';
import { getTempId } from 'utils';
import { PlusIcon } from 'components/icons';
import {
  getDefaultValues,
  getFormInputs,
} from './AddFormSubmissionDocumentModal.forms';
import {
  AddFormSubmissionDocumentModalProps,
  EditFormSubmissionDocumentFormData,
} from './types';

export function AddFormSubmissionDocumentModal(
  props: AddFormSubmissionDocumentModalProps,
): React.ReactElement {
  const { isOpen, onCancel, onConfirm, associationType } = props;
  const [isFormDirty, setIsFormDirty] = React.useState(false);

  const onSubmit = (data: EditFormSubmissionDocumentFormData): void => {
    const { file, description } = data;
    onConfirm?.({
      changeType: ChangeType.Created,
      id: getTempId(),
      description,
      files: [Object.assign(file, { changeType: ChangeType.Created })],
      associationType,
    });
  };

  const formInputs = getFormInputs();
  const defaultValues = React.useMemo(() => getDefaultValues(), []);

  return (
    <FormDialog
      id="addFormSubmissionDocument"
      open={isOpen}
      setOpen={onCancel}
      onIsDirtyChange={setIsFormDirty}
      title="Add Attachment"
      inputs={formInputs}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Add Attachment"
      actionIcon={PlusIcon}
      actionButtonEnabled={isFormDirty}
    />
  );
}
